module.exports = __webpack_public_path__ + "static/media/Style15.3ffa8397.PNG";